// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash/fp';

// Actions
import { endPreviewMode, startPublishPreviewMode } from './previewActions';

// Constants
import { PREVIEW_MODES } from './previewConstants';

const mapDispatchToProps = (dispatch) => ({
    dispatchStartPublishPreviewMode: (startingBoardId) =>
        dispatch(startPublishPreviewMode(startingBoardId, PREVIEW_MODES.PUBLISH_PREVIEW)),
    dispatchDisablePublishPreviewMode: () => dispatch(endPreviewMode()),
});

const PublishPreviewInit = (props) => {
    const { children, close, dispatchStartPublishPreviewMode, dispatchDisablePublishPreviewMode } = props;

    React.useEffect(() => {
        const currentBoardId = get(['params', 'currentBoardId'], props);
        dispatchStartPublishPreviewMode(currentBoardId);
        return dispatchDisablePublishPreviewMode;
    }, []);

    // For the element modal we need to pass the RouteModalManager's close function down
    return React.cloneElement(children, { close });
};

PublishPreviewInit.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    close: PropTypes.func,
    dispatchStartPublishPreviewMode: PropTypes.func,
    dispatchDisablePublishPreviewMode: PropTypes.func,
};

export default connect(null, mapDispatchToProps)(PublishPreviewInit);
